/**
 * Type names are from the material categlog, not by choice.
 * https://fonts.google.com/icons?icon.platform=android&icon.set=Material+Icons
 */
export enum SvgColor {
    stdIcon = "std-icon",
    buttonWithBackground = 'button-with-background',
    error = 'error',
    positive = 'positive',
    disable = 'disable'
}

export enum SvgMatType {
    Pdf = 'picture_as_pdf',
    ExternalLink = 'open_in_new',
    ChevronLeft = 'arrow_back_ios_new',
    ChevronRight = 'arrow_forward_ios',
    CheckMark = 'check',
    RadioButtonChecked = 'radio_button_checked',
    FiberManualRecord = 'fiber_manual_record',
    Info = 'info',
    Gear = 'settings',
    Badge = 'badge',
    Group = 'group',
    Groups = 'groups',
    SmsFailed = 'feedback',
    VideoLibrary = 'video_library',
    Home = 'home',
    SquareCross = 'local_hospital',
    ArrowDropDown = 'arrow_drop_down',
    Person = 'person',
    Profile = 'person',
    Resources = 'description',
    Wrench = 'build',
    ManageAccounts = 'manage_accounts',
    Reports = 'summarize',
    SearchUsers = 'person_search',
    SyncAlt = 'sync_alt',
    AccountBalance = 'account_balance',
    RequestQuote = 'request_quote',
    InsertDriveFile = 'draft',
    Article = 'article',
    Dashboard = 'dashboard',
    Dashboard2 = 'space_dashboard',
    AccountTree ='account_tree',
    Deductions = 'arrow_circle_down',
    Company = 'domain',
    Contacts = 'contact_mail',
    LocationOn = 'location_on',
    PayStub = 'attach_money',
    DirectDeposit = 'account_balance',
    FederalTax = 'assured_workload',
    StateTax = 'id_card',
    PTO = 'local_cafe',
    AvailableBenefits = 'bookmark_star',
    MyBenefits = 'folder_special',
    Beneficiaries = 'family_restroom',
    LifeEventRequests = 'stroller',
    BenefitSummaries = 'add_notes',
    Dependents = 'stroller',
    BenefitDocs = 'medical_services',
    ComplianceDocs = 'check_circle',
    MemberLookup = 'person_search',
    LookupHistory = 'history',
    TestMembers = 'labs',
    MemberCreate = 'ink_pen',
    ExecuteReports = 'insert_chart',
    Agents = 'support_agent',
    CompanyAssignment = 'assignment_turned_in',
    AgentsAssignment = 'assignment_ind',
    CarrierInfo = 'info',
    ServerTests = 'storage',
    SASSReviews = 'format_color_fill',
    Error = 'error',
    Copy = 'content_copy'
}

export enum SvgCustomType {
    Bell = 'Bell',
    Cart = 'Cart',
    CreditCard = 'CreditCard',
    Cross = 'Cross',
    Clipboard = 'Clipboard',
    Home = 'Home',
    NewTab = 'NewTab',
    Profile = 'Profile',
    ShoppingBag = 'ShoppingBag',
}

export enum SVGNavBarColors {
    iconBlue = 'icon-blue',
    iconMint = 'icon-mint',
    iconCoral = 'icon-coral',
    iconCyan = 'icon-cyan',
    iconLavender = 'icon-lavender',
    iconPeach = 'icon-peach',
    iconGray  = 'icon-gray'
}


// Material SVGs  https://materialdesignicons.com/ \\
// Crazy fix//
const xmlns = "http://www.w3.org/2000/svg";
const pathClass = "svg-path";

interface IPathSvg {
    class: string,
    d_Image: string;
    transform: string;
}

export interface ISvg {
    id: string;
    viewbox: string,
    xmlns: string,
    path: IPathSvg[],
    afterPath: string,
}

export function buildCustomSVG(p_SvgCustomType: SvgCustomType) {
    let l_Svg: ISvg;

    switch(p_SvgCustomType) {
        case SvgCustomType.Profile:
        l_Svg = ProfileSVG;
        break;
    }

    let l_Path: string = '';
        l_Svg.path.forEach(p => {
            l_Path += `<path class="${p.class}" d="${p.d_Image}" transform="${p.transform}" />`;
        });

        if (l_Svg.afterPath) l_Path += l_Svg.afterPath;

    return `<svg id="${l_Svg.id}" data-name="${l_Svg.id}" xmlns="${l_Svg.xmlns}" viewBox="${l_Svg.viewbox}">${l_Path}</svg>`;
}

const ProfileSVG: ISvg = {
    id: SvgCustomType.Profile,
    viewbox: "0 0 84.06 84.06",
    xmlns: xmlns,
    path: [
        {
            class: pathClass,
            d_Image: "M48.75,3.74a42,42,0,1,0,42,42A42.07,42.07,0,0,0,48.75,3.74Zm0,79.71a37.52,37.52,0,0,1-25.38-9.86c5.86-8.71,15.05-14.33,25.38-14.33s19.51,5.62,25.37,14.33A37.52,37.52,0,0,1,48.75,83.45Zm28.45-13C70.53,61,60.26,54.91,48.75,54.91S27,61,20.29,70.42a37.69,37.69,0,1,1,56.91,0Z",
            transform: "translate(-6.72 -3.74)",
        },
        {
            class: pathClass,
            d_Image: "M48.75,51.85A17.24,17.24,0,1,1,66,34.61,17.27,17.27,0,0,1,48.75,51.85Zm0-30.14a12.9,12.9,0,1,0,12.89,12.9A12.92,12.92,0,0,0,48.75,21.71Z",
            transform: "translate(-6.72 -3.74)",
        },
    ],
    afterPath: "",
};

//** OLD TEMPLATE
//
// const SVG: ISvg = {
//     id: SvgCustomType,
//     viewbox:"",
//     xmlns: xmlns,
//     path: [
//         {
//             class: pathClass,
//             d_Image: "",
//             transform: "",
//         },
//     ],
//     afterPath: "",
// };
//
// */

